import React from 'react';
import { Card, CardContent, Typography, Grid, IconButton, Box } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import color from '../utils/Colors';

interface Course {
  title: string;
  date: string;
  time: string;
}

interface CourseListProps {
  courses: Course[];
}

const CourseCard: React.FC<Course> = ({ title, date, time }) => {
  return (
    <Card sx={{ marginBottom: '16px', backgroundColor: color.forthColor, color: '#fff', borderRadius: '12px' }}>
      <CardContent>
        <Grid container sx={{display:'flex', gap:'10px'}} alignItems="center">
          <Grid item>
            <IconButton sx={{ backgroundColor: '#68518a', width: '48px', height: '48px', borderRadius: '50%' }}>
              <EventIcon sx={{ color: '#fff' }} />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize:'16px' }}>
              {title}
            </Typography>
            <Typography variant="body2">{date}, {time}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const UnverifiedCourseCard: React.FC<CourseListProps> = ({ courses }) => {
  return (
    <Box
    sx={{
      backgroundColor: color.firstColor,
      color: "white",
      borderRadius: "10px",
      padding: "20px",
      width: "300px",
      height: "350px",
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '6px',
        height: '20px',
      },
      '&::-webkit-scrollbar-track': {
        background: color.secondColor,
        borderRadius: '10px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: color.firstColor,
        border: 'solid 1px white',
        borderRadius: '10px',
      },
    }}
  >
      <Grid container justifyContent="space-between" sx={{display:'flex'}} alignItems="center">
        <Typography variant="h5" sx={{  fontWeight: 'bold' }}>Unverified Courses</Typography>
        <Typography variant="body2" sx={{ color: '#fff' }}>See all</Typography>
      </Grid>
      <div style={{ marginTop: '16px' }}>
        {courses.length === 0 ? (
          <Typography variant="body2">No unverified courses.</Typography>
        ) : (
          courses.map((course, index) => (
            <CourseCard key={index} {...course} />
          ))
        )}
      </div>
      </Box>
  );
};

export default UnverifiedCourseCard;
